import axios from 'axios';
import { useQuery } from 'react-query';
import { Tournament } from '../api/responses';

export const useGetTournament = (id?: string) => {
    const getTournament = async (): Promise<Tournament> => {
        const tour = await axios.get(`${process.env.REACT_APP_API_URL}/competitions/${id}/`).then((res) => res.data)
        return tour;
    };
    const { data, isLoading, isError, error } = useQuery({
        queryKey: ['get-tour'],
        queryFn: getTournament,
        enabled: !!id
    });

    return { data, isError, isLoading, error };
};
